import { ArrowUpRight, Check, MessageSquare, ThumbsUp } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { TopicSummary } from '../types';
import { FlowerButton } from './FlowerButton';

interface TopicRowProps {
  topic: TopicSummary;
  liked: boolean;
  pendingFlowers: number;
  interactionDisabled: boolean;
  likeDisabled: boolean;
  onToggleLike(): void;
  onFlower(): void;
  current?: boolean;
}

export function TopicRow({
  topic,
  liked,
  pendingFlowers,
  interactionDisabled,
  likeDisabled,
  onToggleLike,
  onFlower,
  current = false,
}: TopicRowProps) {
  return (
    <article className={`topic-row ${current ? 'is-current' : ''}`}>
      <div className="topic-order" aria-hidden="true">
        {topic.displayOrder}
      </div>
      <div className="topic-copy">
        <div className="topic-heading">
          <div>
            {current && <span className="current-topic-label">Now presenting</span>}
            <h2>{topic.title}</h2>
            <p>{topic.presenter}</p>
          </div>
          <Link
            className="topic-link"
            to={`/topics/${topic.id}`}
            aria-label={`Open comments for ${topic.title}`}
          >
            <ArrowUpRight aria-hidden="true" />
          </Link>
        </div>
        <div className="topic-actions" aria-label={`${topic.title} interactions`}>
          <button
            className={`reaction-button like is-compact ${liked ? 'is-active' : ''}`}
            disabled={likeDisabled}
            onClick={onToggleLike}
            aria-pressed={liked}
            aria-label={`${liked ? 'Unlike' : 'Like'} ${topic.title}. ${topic.likeCount} likes total`}
          >
            {liked ? <Check /> : <ThumbsUp />}
            <span>{liked ? 'Liked' : 'Like'}</span>
            <strong>{topic.likeCount.toLocaleString()}</strong>
          </button>
          <FlowerButton
            compact
            disabled={interactionDisabled}
            total={topic.flowerCount + pendingFlowers}
            onFlower={onFlower}
          />
          <Link className="comment-link" to={`/topics/${topic.id}`}>
            <MessageSquare aria-hidden="true" />
            <span>Comments</span>
            <strong>{topic.commentCount.toLocaleString()}</strong>
          </Link>
        </div>
      </div>
    </article>
  );
}
